// @ts-ignore
export const stopPropagation = (ref) => {
  // https://stackoverflow.com/questions/63964553/ag-grid-prevent-onrowclicked-event-when-clicking-icon-inside-cell
  if (!ref) return;

  // @ts-ignore
  ref.onclick = (e) => {
    e.stopPropagation();
  };
};
